import "./404.css";
import { useNavigate } from "react-router-dom";
import Fold from "./component/fold/Fold";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className={"not-found vw vh"}>
      <div className="not-found-wrapper">
        <Fold type={"unauthorized"} code_status={401} />
        <h2>Page Unauthorized</h2>
        <p>Sorry! You are not allowed to access the page.</p>
        <button className="button" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
